import React from 'react'

const EllipsisIcon = () => {
	return (
		<svg width='44' height='9' viewBox='0 0 44 9' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M4.5 9C6.98528 9 9 6.98528 9 4.5C9 2.01472 6.98528 0 4.5 0C2.01472 0 0 2.01472 0 4.5C0 6.98528 2.01472 9 4.5 9Z'
				fill='currentColor'
			/>
			<path
				d='M21.5 9C23.9853 9 26 6.98528 26 4.5C26 2.01472 23.9853 0 21.5 0C19.0147 0 17 2.01472 17 4.5C17 6.98528 19.0147 9 21.5 9Z'
				fill='currentColor'
			/>
			<path
				d='M39.5 9C41.9853 9 44 6.98528 44 4.5C44 2.01472 41.9853 0 39.5 0C37.0147 0 35 2.01472 35 4.5C35 6.98528 37.0147 9 39.5 9Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default EllipsisIcon
